import { useChartDisplay } from '../../../../ui-components/data-viz-ui/charts/common/common-chart-utils/use-chart-display-reducer';
import { ComponentStateManager } from '../../../common/types';
import { OverTimeSegmentedVizExternalProps } from '../../types';
import {
  OverTimeSegmentedBarChartActions,
  OverTimeSegmentedBarChartState,
} from './types';

export const useOverTimeSegmentedBarChartStateManager = (
  externalProps: OverTimeSegmentedVizExternalProps,
  persistenceKey: string
): ComponentStateManager<
  OverTimeSegmentedBarChartState,
  OverTimeSegmentedBarChartActions
> => {
  const { displayState, displayActions } = useChartDisplay(
    {
      enablePercentage: true,
      enableStack: true,
      enableLabels: true,
      enableLegend: true,
      enableSortOrder: true,
      enableTableView: true,
      globalDisplayState: externalProps.displayGlobalState,
    },
    persistenceKey
  );

  return {
    state: {
      displayState,
    },
    actions: {
      displayActions,
    },
  };
};
